module.exports = __webpack_public_path__ + "img/ic_path_search.8365d4cf.png";